import theme from "../../theme";

export const card = {
  margin: theme.spacing(2),
};

export const headingSection = {
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(2),
  textAlign: "center",
};

export const subTile = {
  justifyContent: "center",
  textAlign: "center",
};

export const divider = {
  backgroundColor: "white",

  marginLeft: theme.spacing(4),
  marginRight: theme.spacing(4),
};

export const dividerContainer = {
  paddingBottom: theme.spacing(2),
};

export const bookIcon = {};
export const promptBox = {
  border: `2px solid ${theme.palette.primary.main}`,
  padding: theme.spacing(2),
};

export const listScroller = {
  maxHeight: "60vh",
  overflow: "auto",
  backgroundColor: "#000",
};

export const listItem = { width: "auto" };

export const buyButton = { borderRadius: "25px", textTransform: "none" };

export const buyButtonIcon = { fontSize: 40 };

export const bookTitleSmall = { width: "20vh" };
export const bookTitleMediumPlus = { width: "auto" };
export const bookTitleSingleColumn = { width: "28vh" };
